<template>
  <div class="sidebar" :class="{ 'is--fixed': scrollTop > 0 }">
    <el-card>
      <div class="logo"><img :src="$event.Logo" /></div>
      <div class="qr"><img :src="'http://www.dataleading.cn/barcode/img.ashx?type=2d&text='+encodeURIComponent($config.app.host+'/app/#/?v='+$event.ID)" /></div>
      <div class="event-name">{{ $event.EventName }}</div>

      <div class="sponsor">
        <span>{{ $t('index.organizer') }}</span>
        <span class="organizer">{{ $event.Organizer }}</span>
      </div>

      

      <div class="hr"></div>
        <VContact />

      <div class="toolbar">
        <el-button v-if="!$event.EventName.includes('远毅')"  type="primary" plain @click="emit('login','login')">{{ $t('index.confirmation') }}</el-button>
        <el-button v-if="$event.IsClose" type="primary" :disabled="true" >{{["报名截止", "Ended"][$language] }}</el-button>
        <el-button v-else type="primary" @click="emit('login','')">{{ $t('index.register') }}</el-button>  
      </div>
    </el-card>
  </div>
</template>
<script setup>
  import VContact from './contact.vue'

  import { ref, defineEmits, inject, onMounted, onUnmounted } from 'vue'
  const emit = defineEmits(['login'])

  const $event = inject('$event')
  const $config = inject('$config')
   const $language = inject("$language"); 
   console.log($event.EventName)
  console.log($config)
  const scrollTop = ref(0)
  const handleScroll = () => {
    scrollTop.value = document.documentElement.scrollTop
    console.log('scrollTop', scrollTop.value)
  }
  onMounted(() => {
    window.addEventListener('scroll', handleScroll)
  })
  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
  })
</script>

<style lang="scss" scoped>
  .sidebar {
    width: 340px;
    margin-top: 20px;
    &.is--fixed {
      .el-card {
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        width: 340px;
      }
   
      :deep(){
        .share {
        //display: none;
      }
      }
      .toolbar {
        margin-top: 6px;
      }
    }
  }
  .el-card {
    background: rgba(255, 255, 255, 0.93);
    box-shadow: 0px 4px 20px rgba(53, 59, 85, 0.16);
    backdrop-filter: blur(6px);
    border-radius: 12px;
    box-shadow: none;
    border-width: 0;
    :deep() {
      .el-card__header {
        padding: 0;
        height: 68px;
        border-bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .el-card__body {
        padding: 12px 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        color: #363f5e;
        > div {
          text-align: center;
        }
        .logo {
          height: 36px;
          text-align: center;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 12px;
          img {
            height: 36px;
            display: block;
          }
        }
        .el-scrollbar__view {
          height: calc(100vh - 108px);
        }
        .title {
          text-align: center;
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
        }
        .qr {
          background: #efefef;
          border-radius: 12px;
          padding: 8px;
          height: 112px;
          width: 112px;
          text-align: center;
          box-sizing: border-box;
          margin: 0 auto 8px auto;
          img {
            width: 100%;
          }
        }
        .event-name {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          text-align: center;
          margin-bottom: 8px;
            color: #363f5e;
        }
        .sponsor {
          font-size: 14px;
          line-height: 20px;
          span {
            color: rgba(54, 63, 94, 0.5);
          }
          .organizer{
            color: #363f5e;
            margin-left: 12px;
          }
        }
        .hr {
          background: rgba(54, 63, 94, 0.16);
          height: 1px;
          overflow: hidden;
          font-size: 0;
          margin-top: 12px;
          margin-bottom: 12px;
        }
      }
    }
  }

  .toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-button {
      width: calc(50% - 12px);
      margin: 0;
      height: 40px;
    }
  }

  .share {
    background-color: transparent;
    padding: 0;
    :deep() {
      .share-title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-icon {
          flex: 0 0 36px;
          text-align: left;
          justify-content: flex-start;
        }
        span {
          color: rgba(54, 63, 94, 0.5);
          line-height: 22px;
          text-align: left;
          font-size: 14px;
          font-weight: normal;
        }
      }
      .share-content {
        margin-left: 36px;
        justify-content: flex-start;
        .share-item {
          margin-right: 12px;
        }
      }
    }
  }
</style>
